import { observer } from 'mobx-react-lite'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { themeConfig } from '@gap/shared/theme'
import IconButton from '@mui/material/IconButton'
import CloseOutlined from '@mui/icons-material/CloseOutlined'
import OpenInNew from '@mui/icons-material/OpenInNew'
import Download from '@mui/icons-material/Download'
import Tooltip from '@mui/material/Tooltip'
import useStore from 'reusable/mobx-store-utils'
import SkeletonLoader from 'reusable/mui/skeleton/SkeletonLoader'
import ProposalAttachmentStore, { ProposalAttachmentStoreProps } from './ProposalAttachmentStore'

export default observer(function ProposalAttachment(props: ProposalAttachmentStoreProps) {
   const proposalAttachmentStore = useStore((sp) => new ProposalAttachmentStore(sp), props)

   if (proposalAttachmentStore.deleteLoader.isLoading) {
      return <SkeletonLoader loading={true} />
   }

   return <Box
      onClick={proposalAttachmentStore.onAttachmentIconClick}
      sx={{
         cursor: proposalAttachmentStore.canDelete ? 'auto' : 'pointer',
         '&:hover': {
            backgroundColor: themeConfig.primary[200],
         },
         backgroundColor: 'white',
         border: `1px solid ${themeConfig.primary[200]}`,
         borderRadius: '8px',
         width: '100%',
         display: 'flex',
         alignItems: 'center',
         mb: 2,
         px: 1,
      }}
   >
      <Box
         sx={{
            flexGrow: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            mr: 2,
            height: '60px',
         }}
      >
         <proposalAttachmentStore.attachmentIcon sx={{ mx: 1 }} />
         <Box sx={{ ml: 1 }}>
            <Tooltip title={proposalAttachmentStore.primaryText}>
               <Typography variant="body1" sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{proposalAttachmentStore.primaryText}</Typography>
            </Tooltip>
            <Tooltip title={proposalAttachmentStore.secondaryTooltipText}>
               <Typography variant="body2" sx={{ color: themeConfig.primary[600], textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{proposalAttachmentStore.secondaryText}</Typography>
            </Tooltip>
         </Box>
      </Box>
      <Box sx={{ flexShrink: 0, textAlign: 'right', pr: 1, mt: 0.5 }}>
         {proposalAttachmentStore.canDelete && <IconButton onClick={proposalAttachmentStore.onDeleteClick}>
            <CloseOutlined />
         </IconButton>}
         {!proposalAttachmentStore.canDelete && (proposalAttachmentStore.attachmentType === 'file' ? <Download /> : <OpenInNew />)}
      </Box>
   </Box>
})
